import { createFileRoute } from '@tanstack/react-router';

import { ConnectionsSettings } from '#modules/user/features/profile/components/ConnectionsSettings';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/connections'
)({
  component: ConnectionsSettings,
  ssr: false,
});
